import BuildStatus from 'eflex/models/build-status';
import { belongsTo, hasMany, attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import TaskStatuses from 'eflex/constants/task-statuses';

export default class LiveBuildStatus extends BuildStatus {
  @attr('number', { defaultValue: 0 }) elapsedTime;

  @hasMany('build-status-child', { async: false, inverse: 'liveBuildStatus', embedded: true }) children;
  @belongsTo('build-status-multipiece', { async: false, inverse: 'liveBuildStatuses' }) buildStatusMultipiece;
  @hasMany('custom-identifier-datum', {
    inverse: 'liveBuildStatus',
    async: false,
    embedded: true,
  }) customIdentifierData;

  @cached
  get modelRecord() {
    const modelId = this.model?.id ?? this.model?._id;

    if (!modelId) {
      return null;
    }

    return this.store.peekRecord('model', modelId);
  }

  @cached
  get isHolding() {
    return this.isStarted && this.children.some(item => item.hasActiveHold);
  }

  get isContained() {
    return this.status === TaskStatuses.CONTAINED;
  }

  get isFinished() {
    return this.status > 2;
  }

  get isRunning() {
    return this.isStarted && !this.isHolding;
  }

  get statusClass() {
    if (this.isHolding || this.isContained) {
      return 'bg-warning';
    }

    return super.statusClass;
  }

  get statusTranslation() {
    if (this.isHolding) {
      return this.intl.t('hold');
    }

    return super.statusTranslation;
  }

  getChildStatusForTask(task) {
    if (task == null) {
      return null;
    }

    return this.children?.find(item => item.taskId === task.id);
  }
}
